import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
/**
 * Service containing several callables to sort array. To use with Array.sort()
 */
export class SortingService {

  constructor() { }

  /**
   * compareFunction to supply to the Array.sort() function to order content in ascending or descending order
   *
   * @param property litteral "property" to order ASC, "-property" to order DESC
   */
  orderBy(property) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return (a, b) => {
      const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    };
  }
}
